// extracted by mini-css-extract-plugin
module.exports = {"facebookBtn":"FacebookAuth-module__facebookBtn___2NgrM"};